import { rankWith, and, uiTypeIs, schemaMatches } from '@jsonforms/core';
import { withJsonFormsEnumProps } from '@jsonforms/react';
import SelectColorPickerControl from '../../components/selectColorPickerControl';
import isEmpty from 'lodash/isEmpty';

const isSelectColorPickerControl = and(
  uiTypeIs('Control'),
  schemaMatches(
    (schema) => !isEmpty(schema) && schema.format === 'selectColorPicker'
  )
);

const customSelectColorPickerControlTester = rankWith(
  4,
  isSelectColorPickerControl
);

export default {
  tester: customSelectColorPickerControlTester,
  renderer: withJsonFormsEnumProps(SelectColorPickerControl),
};
